/**
 * How much of the founder block a visitor can see. The story starts only once
 * the block is reached: most of it on screen, or, for a block taller than the
 * window, most of the window filled. While a glimpse of the top edge shows, the
 * visitor is still reading the heading above, so the first step waits.
 */
export type FounderMapVisibility = "out" | "glimpse" | "watching" | "reached";

/** Share of the block, or of the window for a taller block, that starts the story. */
export const FOUNDER_MAP_REACHED = 0.6;
/** Share below which a started story pauses until the visitor scrolls back. */
export const FOUNDER_MAP_WATCHING = 0.3;

export function founderMapVisibility({
  intersecting,
  ratio,
  visibleHeight,
  viewportHeight,
}: {
  intersecting: boolean;
  ratio: number;
  visibleHeight: number;
  viewportHeight: number;
}): FounderMapVisibility {
  if (!intersecting) return "out";

  const share = Math.max(ratio, viewportHeight > 0 ? visibleHeight / viewportHeight : 0);

  if (share >= FOUNDER_MAP_REACHED) return "reached";
  if (share >= FOUNDER_MAP_WATCHING) return "watching";
  return "glimpse";
}

/**
 * Whether a step's progress bar really ran out, from its `animationend` elapsed
 * time in seconds. When a bar paused at its start resumes, Chrome can place the
 * restart a fraction of a millisecond late; the bar drops back before its start
 * for one frame and ends with no time elapsed. Moving on then skipped step 01.
 */
export function founderStepRanOut(elapsedSeconds: number) {
  return elapsedSeconds > 0;
}
